// Angular imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// Module imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';
import { SharedModule } from '../../../shared-module/shared.module';
import { ManagementCommonModule } from '../../../management-common/management-common.module';

// Devextreme imports
import {
    DxBoxModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxSelectBoxModule,
    DxToolbarModule,
    DxFormModule,
    DxNumberBoxModule,
    DxTextBoxModule,
    DxTextAreaModule,
    DxDateBoxModule,
    DxPopupModule,
    DxSwitchModule,
    DxDataGridModule,
    DxDropDownButtonModule,
    DxMenuModule,
    DxRadioGroupModule,
    DxValidatorModule,
    DxFileUploaderModule
} from 'devextreme-angular';

// Component imports
import { ArchitecturalApplicationEditorComponent } from './architectural-application-editor.component';
import { ApplicationChangeOwnerEditorComponent } from '../application-change-owner-editor/application-change-owner-editor.component';
import { ArchitectualApplicationNotesEditorComponent } from '../architectual-application-notes-editor/architectual-application-notes-editor.component';
import { ArchitecturalApplicationTransactionLogComponent } from '../architectural-application-transaction-log/architectural-application-transaction-log.component';
import { ArchitecturalApplicationAttachmentEditorComponent } from '../architectural-application-attachment-editor/architectural-application-attachment-editor.component';
import { ArchitecturalApplicationEmailAttachmentSelectorComponent } from '../architectural-application-email-attachment-selector/architectural-application-email-attachment-selector.component';
import { LineItemFormEditorComponent } from '../line-item-form-editor/line-item-form-editor.component';
import { BoardApprovalRulesComponent } from '../board-approval-rules/board-approval-rules.component';

@NgModule({
    declarations: [
        ArchitecturalApplicationEditorComponent,
        LineItemFormEditorComponent,
        ApplicationChangeOwnerEditorComponent,
        BoardApprovalRulesComponent,
        ArchitectualApplicationNotesEditorComponent,
        ArchitecturalApplicationTransactionLogComponent,
        ArchitecturalApplicationAttachmentEditorComponent,
        ArchitecturalApplicationEmailAttachmentSelectorComponent
    ],
    imports: [
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        SharedModule,
        ManagementCommonModule,
        DxBoxModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxFormModule,
        DxNumberBoxModule,
        DxTextBoxModule,
        DxTextAreaModule,
        DxDateBoxModule,
        DxPopupModule,
        DxSwitchModule,
        DxDataGridModule,
        DxDropDownButtonModule,
        DxMenuModule,
        DxRadioGroupModule,
        DxValidatorModule,
        DxFileUploaderModule
    ],
    exports: [
        ArchitecturalApplicationEditorComponent,
        LineItemFormEditorComponent,
        ApplicationChangeOwnerEditorComponent,
        BoardApprovalRulesComponent,
        ArchitectualApplicationNotesEditorComponent,
        ArchitecturalApplicationTransactionLogComponent,
        ArchitecturalApplicationAttachmentEditorComponent,
        ArchitecturalApplicationEmailAttachmentSelectorComponent
    ]
})
export class ArchitectualApplicationEditorModule {}
